import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CTASection from './components/CTASection';
import CategoryGrid from './components/CategoryGrid';
import FeatureScroll from './components/FeatureScroll';
import SEOSection from './components/SEOSection';
import ArticlesSection from './components/ArticlesSection';
import Testimonials from './components/Testimonials';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hoobuy.cam';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hoobuy Spreadsheet',
  url: `${siteUrl}/`,
  description: 'Lista completa de produtos da China com sneakers, streetwear e acessórios. Hoobuy Spreadsheet 2025 atualizado.',
  inLanguage: 'pt',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/artigo/{search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Hoobuy.cam',
  url: `${siteUrl}/`,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/879fae149d7d175a673508cd1be74143.jpeg',
  description: 'O guia mais completo do Hoobuy Spreadsheet 2025 para compras da China.',
};

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CTASection />
        <CategoryGrid />
        <FeatureScroll />
        <SEOSection />
        <ArticlesSection />
        <Testimonials />
      </main>

      <Footer />
    </div>
  );
}